import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import { withRouter } from "react-router-dom";

import Button from "@mui/material/Button";

import WithOverlay from "../../popups/withOverlayHoc";
import {
  setLookOpened,
  setLookOverlayOpened,
  setLookPageOpened,
  setLookReturnAction
} from "../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import {ROUTES} from "../../../routes";
import {getCurrentLayout} from "../../appLayout";
import WithSavePostMessage from "../hocs/withSavePostMessage";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import WithUpdateLookCartItem from "../hocs/withUpdateLookCartItem";
import {isIframe} from "../../../misc/helpers";
import {applyNewPreset} from "../lookNavigation/lookNavigationFunctions";

const LookQuestionPopup = (props) => {

  const {lookOverlayOpened, setLookOverlayOpened, setLookPageOpened, history, lookViewChangeOptions, bvPresets,
    activePreset, setLookOpened, lookReturnAction, fabricatorData, setLookReturnAction, loadedPresets} = props;
  const questionPopups = [
    LOOK_OVERLAYS.questionLogin,
    LOOK_OVERLAYS.questionShare,
    LOOK_OVERLAYS.questionView,
    LOOK_OVERLAYS.questionViewUpdated,
    LOOK_OVERLAYS.reset,
    LOOK_OVERLAYS.saveSucess,
  ];

  if (!lookOverlayOpened || !questionPopups.some(popupType => popupType === lookOverlayOpened)) {
    return null
  }

  const closePopup = (hideOverlay) => {
    if (lookReturnAction) {
      setLookReturnAction("");
    }
    hideOverlay(() => {
      setLookOverlayOpened("");
    })
  }

  const submitButtonClick = (hideOverlay, savePostMessage, updateLookCartItem) => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionLogin:
      case LOOK_OVERLAYS.questionShare: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productPopupLogin
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookPopupLogin;
        Analytics.sendClickEvent(analyticsLabel);
        const isLixil = isIframe() && fabricatorData.isLixil;
        if (lookOverlayOpened === LOOK_OVERLAYS.questionShare && !isLixil) { // we will show login popup so no need to close overlay
          setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
          break;
        }
        closePopup(hideOverlay);
        setLookPageOpened("");
        // history.push(ROUTES.login);
        savePostMessage();

        break;
      }
      case LOOK_OVERLAYS.questionView: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productPopupChangeViewSubmit
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookPopupChangeViewSubmit;
        Analytics.sendClickEvent(analyticsLabel);

        const {newLayoutType, newScene} = lookViewChangeOptions;
        const layout = getCurrentLayout();
        layout.selectLayout(newLayoutType, null, null, newScene, () => {
          setLookPageOpened("");
          if (IS_PRODUCT_JOURNEY) {
            setLookOpened(null);
          }
          history.push(ROUTES.home);
          closePopup(hideOverlay);
          updateLookCartItem();
        });
        // setLookOverlayOpened(LOOK_OVERLAYS.questionViewUpdated);
        break;
      }
      case LOOK_OVERLAYS.questionViewUpdated: {
        closePopup(hideOverlay);
        setLookPageOpened("");
        history.push(ROUTES.home);
        break;
      }
      case LOOK_OVERLAYS.reset: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productPopupResetSubmit
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookPopupSaveResetSubmit;
        Analytics.sendClickEvent(analyticsLabel);

        closePopup(hideOverlay);
        setLookPageOpened("");
        history.push(ROUTES.home);

        let presetToSet = null;
        if (Number.isInteger(activePreset)) {
          presetToSet = bvPresets.find(preset => preset.id === activePreset);
        }
        if (!presetToSet) {
          presetToSet = bvPresets.find(preset => preset.loadByTheDefault)
        }
        if (presetToSet) {
          console.log("defaultPreset", presetToSet);
          applyNewPreset(presetToSet, loadedPresets);
        }
        break;
      }
      case LOOK_OVERLAYS.saveSucess: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productPopupSaveSuccessSubmit
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookPopupSaveSuccessSubmit;
        Analytics.sendClickEvent(analyticsLabel);
        closePopup(hideOverlay);
        break;
      }
    }
  }

  const getTitle = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionLogin: { // is only for lixil
        return isIframe() ? "questionPopup.wishlist.title" : "questionPopup.wishlist.title2"
      }
      case LOOK_OVERLAYS.questionShare: {
        return "questionPopup.share.title"
      }
      case LOOK_OVERLAYS.questionView: {
        return "questionPopup.view.title"
      }
      case LOOK_OVERLAYS.questionViewUpdated: {
        return "questionPopup.viewUpdated.title"
      }
      case LOOK_OVERLAYS.reset: {
        return "resetPopup.title"
      }
      case LOOK_OVERLAYS.saveSucess: {
        return "savePopup.title"
      }
    }
    return ""
  }

  const getDescription = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionLogin: {
        return "questionPopup.wishlist.text"
      }
      case LOOK_OVERLAYS.questionShare: {
        return "questionPopup.share.text"
      }
      case LOOK_OVERLAYS.questionView: {
        return "questionPopup.view.text"
      }
      case LOOK_OVERLAYS.questionViewUpdated: {
        return "questionPopup.viewUpdated.text"
      }
      case LOOK_OVERLAYS.reset: {
        return "resetPopup.text"
      }
      case LOOK_OVERLAYS.saveSucess: {
        return "savePopup.text"
      }
    }
    return ""
  }

  const getButtonText = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionViewUpdated: {
        return "questionPopup.viewUpdated.button"
      }
      case LOOK_OVERLAYS.reset: {
        return "buttons.yes"
      }
      case LOOK_OVERLAYS.saveSucess: {
        return "buttons.continue"
      }
    }
    return "buttons.confirm"
  }


  return (
    <WithOverlay>
      {(hideOverlay) => (
        <div className="look-popup look-popup--question">
          <div className="look-popup__content">
            <h2 className="h2 h2--regular text-left">
              <FormattedMessage id={getTitle()}/>
            </h2>
            <p className="text text-left">
              <FormattedMessage id={getDescription()}/>
            </p>
          </div>
          <div className={"look-popup__buttons"
          + (lookOverlayOpened === LOOK_OVERLAYS.questionViewUpdated ? " look-popup__buttons--right" : "")}>
            {lookOverlayOpened === LOOK_OVERLAYS.questionViewUpdated || lookOverlayOpened === LOOK_OVERLAYS.saveSucess ? null : (
              <Button className={"look-button look-button--secondary look-button--min"}
                      onClick={() => closePopup(hideOverlay)}>
                <FormattedMessage id="buttons.cancel"/>
              </Button>
            )}
            <WithUpdateLookCartItem>
              {(updateLookCartItem) => (
                <WithSavePostMessage>
                  {(savePostMessage) => (
                    <Button className={"look-button look-button--primary"
                      + (lookOverlayOpened === LOOK_OVERLAYS.questionViewUpdated ? " look-button--large" : " look-button--min")}
                            onClick={() => submitButtonClick(hideOverlay, savePostMessage, updateLookCartItem)}>
                      <FormattedMessage id={getButtonText()}/>
                    </Button>
                  )}
                </WithSavePostMessage>
              )}
            </WithUpdateLookCartItem>
          </div>
        </div>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookOverlayOpened, lookViewChangeOptions, lookReturnAction} = store.lookState;
  const {bvPresets, activePreset, loadedPresets} = store.bathroomVisualizerState;
  const fabricatorData = store.fabricatorState;

  return {
    lookOverlayOpened,
    lookViewChangeOptions,
    bvPresets,
    loadedPresets,
    activePreset,
    lookReturnAction,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookPageOpened,
  setLookOpened,
  setLookReturnAction,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookQuestionPopup)
)
